// extracted by mini-css-extract-plugin
export default {"wrapper":"xt-z","response":"yt-z","error":"zt-z","disabled":"At-z","buttons":"Bt-z","feedbackQuestionSection":"Ct-z","yesNoWrapper":"Dt-z"};